module.exports = __webpack_public_path__ + "a2199f7d33a87a44e0e2bb130c1e9823.jpg";